import React from 'react';
import {Outlet} from 'react-router-dom';

import {APP_HEADER_HEIGHT} from '../../theme';

export const PSO_ICON_COLORS = [
  '#4A90A4',
  '#7B68A6',
  '#5D8A66',
  '#C4785C',
  '#8B6B61',
  '#6B8E8E',
  '#9B7BB8',
  '#5C8C5C',
];

export const getColorByOrgHash = (orgId) => {
  if (!orgId) return PSO_ICON_COLORS[0];
  let hash = 0;
  for (let i = 0; i < orgId.length; i++) {
    hash = (hash << 5) - hash + orgId.charCodeAt(i);
    hash = hash & hash;
  }
  const index = Math.abs(hash) % PSO_ICON_COLORS.length;
  return PSO_ICON_COLORS[index];
};

export const sharedStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    width: '100%',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginLeft: '3rem',
    marginRight: '3rem',
  },
  stickyHeader: {
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    paddingTop: `calc(${APP_HEADER_HEIGHT} + 2.5rem)`,
    paddingBottom: '1.25rem',
    width: '100%',
    maxWidth: '1268px',
  },
  scrollableContent: {
    flex: 1,
    width: '100%',
    maxWidth: '1268px',
    overflowY: 'auto',
    paddingBottom: '2rem',
  },
};

const ExternalUserLandingPage = () => {
  return (
    <div style={sharedStyles.container}>
      <Outlet />
    </div>
  );
};

export default ExternalUserLandingPage;
